var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"permission-management-page"},[_c('permission-management')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }